import api from '../utils/request';

export const authAPI = {
  // 登录
  login: (data) => api.post('/auth/login', data),
  
  // 注册
  register: (data) => api.post('/auth/register', data),
  
  // 获取当前用户信息
  getCurrentUser: () => api.get('/auth/me')
};

export const productAPI = {
  // 获取商品列表
  getList: (params) => api.get('/products', { params }),
  
  // 获取商品详情
  getDetail: (id) => api.get(`/products/${id}`),
  
  // 创建商品
  create: (data) => api.post('/products', data),
  
  // 更新商品
  update: (id, data) => api.put(`/products/${id}`, data),
  
  // 删除商品
  delete: (id) => api.delete(`/products/${id}`)
};

export const customerAPI = {
  getList: (params) => api.get('/customers', { params }),
  getDetail: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`)
};

export const supplierAPI = {
  getList: (params) => api.get('/suppliers', { params }),
  getDetail: (id) => api.get(`/suppliers/${id}`),
  create: (data) => api.post('/suppliers', data),
  update: (id, data) => api.put(`/suppliers/${id}`, data),
  delete: (id) => api.delete(`/suppliers/${id}`)
};

export const salesOrderAPI = {
  getList: (params) => api.get('/sales-orders', { params }),
  getDetail: (id) => api.get(`/sales-orders/${id}`),
  create: (data) => api.post('/sales-orders', data),
  update: (id, data) => api.put(`/sales-orders/${id}`, data),
  delete: (id) => api.delete(`/sales-orders/${id}`),
  confirm: (id) => api.put(`/sales-orders/${id}/confirm`),
  cancel: (id) => api.put(`/sales-orders/${id}/cancel`),
  getStats: () => api.get('/sales-orders/stats/summary')
};

export const purchaseOrderAPI = {
  getList: (params) => api.get('/purchase-orders', { params }),
  getDetail: (id) => api.get(`/purchase-orders/${id}`),
  create: (data) => api.post('/purchase-orders', data),
  update: (id, data) => api.put(`/purchase-orders/${id}`, data),
  delete: (id) => api.delete(`/purchase-orders/${id}`),
  confirm: (id) => api.put(`/purchase-orders/${id}/confirm`),
  cancel: (id) => api.put(`/purchase-orders/${id}/cancel`),
  getStats: () => api.get('/purchase-orders/stats/summary')
};

export const inventoryAPI = {
  getList: (params) => api.get('/inventory', { params }),
  getDetail: (id) => api.get(`/inventory/${id}`),
  stockIn: (data) => api.post('/inventory/in', data),
  stockOut: (data) => api.post('/inventory/out', data),
  transfer: (data) => api.post('/inventory/transfer', data),
  adjust: (data) => api.post('/inventory/adjust', data),
  lock: (data) => api.post('/inventory/lock', data),
  unlock: (data) => api.post('/inventory/unlock', data),
  getTransactions: (params) => api.get('/inventory/transactions/list', { params }),
  getProductDistribution: (productId) => api.get(`/inventory/product/${productId}/distribution`),
  getAlerts: (params) => api.get('/inventory/alerts/list', { params }),
  getStats: () => api.get('/inventory/stats/summary')
};

export const warehouseAPI = {
  getList: (params) => api.get('/warehouses', { params }),
  getDetail: (id) => api.get(`/warehouses/${id}`),
  create: (data) => api.post('/warehouses', data),
  update: (id, data) => api.put(`/warehouses/${id}`, data),
  delete: (id) => api.delete(`/warehouses/${id}`),
  getOptions: () => api.get('/warehouses/options/list'),
  getInventoryStats: (id) => api.get(`/warehouses/${id}/inventory-stats`),
  getInventory: (id, params) => api.get(`/warehouses/${id}/inventory`, { params })
};

// 应收账款API
export const receivableAPI = {
  getList: (params) => api.get('/finance/receivables', { params }),
  getDetail: (id) => api.get(`/finance/receivables/${id}`),
  create: (data) => api.post('/finance/receivables', data),
  update: (id, data) => api.put(`/finance/receivables/${id}`, data),
  delete: (id) => api.delete(`/finance/receivables/${id}`),
  receive: (id, data) => api.post(`/finance/receivables/${id}/receive`, data),
  getStats: () => api.get('/finance/receivables/stats/summary')
};

// 应付账款API
export const payableAPI = {
  getList: (params) => api.get('/finance/payables', { params }),
  getDetail: (id) => api.get(`/finance/payables/${id}`),
  create: (data) => api.post('/finance/payables', data),
  update: (id, data) => api.put(`/finance/payables/${id}`, data),
  delete: (id) => api.delete(`/finance/payables/${id}`),
  pay: (id, data) => api.post(`/finance/payables/${id}/pay`, data),
  getStats: () => api.get('/finance/payables/stats/summary')
};

// 收付款记录API
export const paymentAPI = {
  getList: (params) => api.get('/finance/payments', { params }),
  getDetail: (id) => api.get(`/finance/payments/${id}`),
  getStats: () => api.get('/finance/payments/stats/summary')
};

// 财务总览API
export const financeAPI = {
  getDashboard: () => api.get('/finance/dashboard/summary')
};

// 报表API
export const reportAPI = {
  // 销售报表
  getSalesSummary: (params) => api.get('/reports/sales/summary', { params }),
  getSalesByCustomer: (params) => api.get('/reports/sales/by-customer', { params }),
  getSalesByProduct: (params) => api.get('/reports/sales/by-product', { params }),
  getSalesTrend: (params) => api.get('/reports/sales/trend', { params }),

  // 采购报表
  getPurchaseSummary: (params) => api.get('/reports/purchase/summary', { params }),
  getPurchaseBySupplier: (params) => api.get('/reports/purchase/by-supplier', { params }),
  getPurchaseByProduct: (params) => api.get('/reports/purchase/by-product', { params }),

  // 库存报表
  getInventorySummary: () => api.get('/reports/inventory/summary'),
  getInventoryTransactions: (params) => api.get('/reports/inventory/transactions', { params }),
  getInventoryTurnover: (params) => api.get('/reports/inventory/turnover', { params }),

  // 财务报表
  getFinanceSummary: (params) => api.get('/reports/finance/summary', { params }),
  getReceivableAging: () => api.get('/reports/finance/receivable-aging'),
  getPayableAging: () => api.get('/reports/finance/payable-aging'),
  getCashflowTrend: (params) => api.get('/reports/finance/cashflow-trend', { params }),

  // Dashboard
  getDashboard: () => api.get('/reports/dashboard')
};

// 系统管理 - 用户API
export const userAPI = {
  getList: (params) => api.get('/system/users', { params }),
  getDetail: (id) => api.get(`/system/users/${id}`),
  create: (data) => api.post('/system/users', data),
  update: (id, data) => api.put(`/system/users/${id}`, data),
  delete: (id) => api.delete(`/system/users/${id}`),
  resetPassword: (id, data) => api.put(`/system/users/${id}/reset-password`, data),
  changePassword: (data) => api.put('/system/users/change-password', data)
};

// 系统管理 - 角色API
export const roleAPI = {
  getList: (params) => api.get('/system/roles', { params }),
  getOptions: () => api.get('/system/roles/options'),
  getDetail: (id) => api.get(`/system/roles/${id}`),
  create: (data) => api.post('/system/roles', data),
  update: (id, data) => api.put(`/system/roles/${id}`, data),
  delete: (id) => api.delete(`/system/roles/${id}`),
  getPermissions: () => api.get('/system/permissions'),
  initRoles: () => api.post('/system/init-roles')
};

// 系统管理 - 操作日志API
export const logAPI = {
  getList: (params) => api.get('/system/logs', { params }),
  getDetail: (id) => api.get(`/system/logs/${id}`),
  getStats: (params) => api.get('/system/logs/stats/summary', { params }),
  cleanup: (data) => api.delete('/system/logs/cleanup', { data })
};

// 数据导出API
export const exportAPI = {
  // 获取导出URL（直接下载）
  getExportUrl: (type, params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const baseUrl = process.env.REACT_APP_API_URL || '/api';
    return `${baseUrl}/export/${type}${queryString ? '?' + queryString : ''}`;
  },
  // 获取导入模板URL
  getTemplateUrl: (type) => {
    const baseUrl = process.env.REACT_APP_API_URL || '/api';
    return `${baseUrl}/export/template/${type}`;
  }
};

// 数据导入API
export const importAPI = {
  products: (formData) => api.post('/import/products', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  customers: (formData) => api.post('/import/customers', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  suppliers: (formData) => api.post('/import/suppliers', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
};
